<template>
    <transition name="preview" appear>
        <div id="preview-wrapper" class="preview__wrapper">
            <h2 v-show="isFinalStep" id="download-headline">
                Sieht super aus!
            </h2>
            <transition name="dimension-update"
                        appear
                        appear-class="dimension-update-enter"
                        appear-active-class="dimension-update-active"
            >
                <div v-show="!dimensionUpdate" id="device-wrapper" class="device__wrapper">
                    <v-touch
                            @panstart="onPanStart"
                            @panmove="onPanMove"
                            @panend="onPanEnd"
                            @pinchin="OnPinchIn"
                            @pinchout="OnPinchOut"
                    >
                        <div id="device-glow" :style="glowBackground"></div>

                        <div id="device-interaction-area" :class="interactionAreaClass"></div>
                    </v-touch>

                    <img id="device-border-image"/>

                    <div id="device-border-canvas">
                        <canvas id="device-canvas" class="device__canvas"></canvas>
                    </div>

                    <div v-show="isFinalStep" id="final-footer" class="final-footer">
                        <a @click="saveWallpaper" class="button button--secondary" id="download-link">
                            Wallpaper speichern
                        </a>
                        <a v-show="isFinalStep" id="back-link"
                           @click="backToGenerator"
                        >
                            zurück
                        </a>
                    </div>
                </div>
            </transition>
            <transition name="zoom-control" appear>
                <template v-if="currentPanel == 1">
                    <div class="zoom-control">
                        <button class="zoom-button zoom-increase" @click="patternZoom += 1"></button>
                        <div class="zoom-slide">
                            <vue-slider
                                    ref="slider"
                                    v-model="patternZoom"
                                    v-bind="sliderOptions"
                                    @input="onZoomChange"
                            ></vue-slider>
                        </div>
                        <button class="zoom-button zoom-decrease" @click="patternZoom -= 1"></button>
                    </div>
                </template>
            </transition>


        </div>
    </transition>
</template>

<script>
    import vueSlider from 'vue-slider-component';
    import {saveAs} from 'file-saver/FileSaver';

    export default {
        components: {
            vueSlider
        },
        data() {
            return {
                previewCanvas: null,
                ctx: null,
                devicePadding: 10,
                designX: 0,
                kudosImage: null,
                kudosPosition: null,
                kudosDimensions: null,
                logoImage: null,
                patternImage: null,
                patternZoom: 15,
                patternPosition: {
                    'x': 0,
                    'y': 0
                },
                sliderOptions: {
                    value: 1,
                    width: 4,
                    height: 272,
                    dotHeight: 40,
                    dotWidth: 15,
                    min: 11,
                    max: 60,
                    interval: 1,
                    tooltip: "false",
                    bgStyle: {
                        "backgroundColor": "#D5D5D5",
                        "width": "8px"
                    },
                    processStyle: {backgroundColor: '#000', width: '8px'},
                    sliderStyle: {marginLeft: '2px'},
                    direction: "vertical",
                    speed: 0.5
                },
                wallpaperScale: 1,
                dimensionUpdate: false,
                panPosition: {
                    x: null,
                    y: null,
                },
                showPinchTooltip: true
            };
        },
        props: ['currentPanel', 'wallpaper'],
        computed: {
            glowBackground() {
                let imgSrc = require('../../assets/patterns/' + this.wallpaper.pattern.name + '.svg')
                if (this.wallpaper.pattern.isBW) {
                    imgSrc = require('../../assets/patterns/' + this.wallpaper.pattern.name + '_bw.svg')
                }
                return 'background-image: url(' + imgSrc + ')';
            },
            isFinalStep() {
                if (this.currentPanel == 3) {
                    return true;
                } else {
                    return false;
                }
            },
            interactionAreaClass() {
                let interActionClasses = 'panel--' + this.currentPanel;
                ;
                if (this.showPinchTooltip && this.currentPanel == 1) {
                    interActionClasses += ' pinch-tool-tip'
                }
                return interActionClasses;
            }

        },
        methods: {
            backToGenerator() {
                this.eventHub.$emit('panelChange', 'prev');
            },
            onPanStart(event) {
                this.panPosition.x = event.changedPointers[0].clientX;
                this.panPosition.y = event.changedPointers[0].clientY;
                this.showPinchTooltip = false;
            },
            onPanMove(event) {
                if (this.currentPanel == 1) {
                    let deltaX = (this.panPosition.x - event.changedPointers[0].clientX);
                    let deltaY = (this.panPosition.y - event.changedPointers[0].clientY);
                    this.patternPosition.x += deltaX;
                    this.patternPosition.y += deltaY;
                    this.panPosition.x = event.changedPointers[0].clientX;
                    this.panPosition.y = event.changedPointers[0].clientY;
                    this.drawWallpaper(this.previewCanvas);
                }
            },
            onPanEnd() {
                this.panPosition.x = null;
                this.panPosition.y = null;
            },
            OnPinchOut(event) {
                if (this.currentPanel == 1) {
                    this.patternZoom += (event.scale * 0.8);
                    if (this.patternZoom > 50) this.patternZoom = 50;
                    this.drawWallpaper(this.previewCanvas);
                    this.showPinchTooltip = false;
                }
            },
            OnPinchIn(event) {
                if (this.currentPanel == 1) {
                    this.patternZoom -= (event.scale * 0.8);
                    if (this.patternZoom < 10) this.patternZoom = 10;
                    this.drawWallpaper(this.previewCanvas);
                    this.showPinchTooltip = false;
                }
            },
            drawWallpaper(canvas) {
                let context = canvas.getContext("2d")
                this.drawPattern(canvas, context);
            },
            drawPattern(canvas, context) {
                context.fillStyle = "black";
                context.fillRect(0, 0, canvas.width, canvas.height);

                let vm = this;
                let scaleFactor = vm.patternZoom / 10;

                if (vm.wallpaper.pattern.name == 'sipgate') {
                    scaleFactor = vm.patternZoom / 6;
                }

                let canvasMaxSize = Math.max(canvas.width, canvas.height);
                let imageWidth = Math.floor(canvasMaxSize * scaleFactor);
                let imageHeight = Math.floor(canvasMaxSize * scaleFactor);

                let patternOffSetX = this.patternPosition.x * canvas.width / 500;
                let patternOffSetY = this.patternPosition.y * canvas.height / 500;

                let imagePositionX = Math.floor(((imageWidth - canvas.width) / 2) * -1) - patternOffSetX;
                let imagePositionY = Math.floor(((imageHeight - canvas.height) / 2) * -1) - patternOffSetY;

                // Border Detection - Bottom
                let maxY = ((imageHeight - canvas.height) / 2);
                if (patternOffSetY > maxY) {
                    imagePositionY = (imageHeight - canvas.height) * -1;
                    this.patternPosition.y = maxY / canvas.height * 500
                }

                // Border Detection - Top
                let minY = maxY * -1;
                if (patternOffSetY < minY) {
                    imagePositionY = 0;
                    this.patternPosition.y = minY / canvas.height * 500
                }

                // Border Detection - Right
                let maxX = ((imageWidth - canvas.width) / 2);
                if (patternOffSetX > maxX) {
                    imagePositionX = (imageWidth - canvas.width) * -1;
                    this.patternPosition.x = maxX / canvas.width * 500;
                }

                // Border Detection - Left
                let minX = maxX * -1;
                if (patternOffSetX < minX) {
                    imagePositionX = 0;
                    this.patternPosition.x = minX / canvas.width * 500;
                }

                if (vm.patternImage == null) {
                    vm.patternImage = new Image();
                    vm.patternImage.crossOrigin = "anonymous";
                    vm.patternImage.onload = function () {
                        try {
                            context.drawImage(vm.patternImage, imagePositionX, imagePositionY, imageWidth, imageHeight);
                        }
                        catch (err) {
                            setTimeout(function () {
                                context.drawImage(vm.patternImage, imagePositionX, imagePositionY, imageWidth, imageHeight);
                            }, 0);
                        }
                        vm.drawLogo(canvas, context);
                    }
                    if (vm.wallpaper.pattern.isBW) {
                        vm.patternImage.src = require('../../assets/patterns/' + this.wallpaper.pattern.name + '_bw' + '.svg');
                    } else {
                        vm.patternImage.src = require('../../assets/patterns/' + this.wallpaper.pattern.name + '.svg');
                    }
                    vm.patternImage.onload = function () {
                        context.drawImage(vm.patternImage, imagePositionX, imagePositionY, imageWidth, imageHeight);
                        vm.drawLogo(canvas, context);
                    }
                } else {
                    context.drawImage(vm.patternImage, imagePositionX, imagePositionY, imageWidth, imageHeight);
                    vm.drawLogo(canvas, context);
                }
            },

            drawLogo(canvas, context) {
                let vm = this;
                if (vm.wallpaper.logo) {
                    if (vm.wallpaper.logoImage == null) {
                        vm.wallpaper.logoImage = new Image();
                        vm.wallpaper.logoImage.crossOrigin = "anonymous";
                        vm.wallpaper.logoImage.onload = function () {
                            vm.drawLogoOnCanvas(canvas, context, vm);
                            vm.drawKudos(canvas, context);
                        }
                        if (vm.wallpaper.pattern.isBW) {
                            vm.wallpaper.logoImage.src = require('../../assets/logos/logo-sipgate.svg');
                        } else {
                            vm.wallpaper.logoImage.src = require('../../assets/logos/logo-' + vm.wallpaper.pattern.name + '.svg');
                        }

                        vm.wallpaper.logoImage.onload = function () {
                            vm.drawLogoOnCanvas(canvas, context, vm);
                            vm.drawKudos(canvas, context);
                        }
                    } else {
                        this.drawLogoOnCanvas(canvas, context, vm);
                        vm.drawKudos(canvas, context);
                    }
                } else {
                    vm.drawKudos(canvas, context);
                }
            },

            drawLogoOnCanvas(canvas, context, vm) {
                // Retrieve designX for corporate design
                let shortSide = canvas.width;
                let longSide = canvas.height;
                let orientation = 'portrait';
                if (canvas.width > canvas.height) {
                    shortSide = canvas.height;
                    longSide = canvas.width;
                    orientation = 'landscape';
                }

                if (orientation == 'landscape') {
                    vm.designX = Math.floor(shortSide / 14);
                } else {
                    if ((longSide / shortSide) < 2) {
                        vm.designX = Math.floor(shortSide / 14);
                    } else {
                        vm.designX = Math.floor(canvas.width / 9);
                    }
                }

                let aspectRatio = 3.3207;
                if (!vm.wallpaper.pattern.isBW) {
                    aspectRatio = vm.wallpaper.pattern.aspectRatio;
                }
                let logoWidth = Math.floor(vm.designX * aspectRatio);
                let logoPositionY = vm.designX;

                if (vm.wallpaper.device) {
                    let scale = canvas.height / vm.wallpaper.device.height;
                    let cameraOffset = vm.wallpaper.device.border.camera * scale;
                    logoPositionY += cameraOffset;
                }
                logoPositionY = Math.floor(logoPositionY);
                try {
                    context.drawImage(vm.wallpaper.logoImage, vm.designX, logoPositionY, logoWidth, vm.designX);
                }
                catch (err) {
                    setTimeout(function () {
                        context.drawImage(vm.wallpaper.logoImage, vm.designX, logoPositionY, logoWidth, vm.designX);
                    }, 0);
                }
            },


            drawKudos(canvas, context) {
                let vm = this;
                if (vm.wallpaper.kudos != null) {
                    if (vm.kudosImage == null) {
                        vm.kudosImage = new Image();
                        vm.kudosImage.crossOrigin = "anonymous";
                        vm.kudosImage.onload = function () {
                            vm.drawKodusOnCanvas(canvas, context, vm);
                        }
                        vm.kudosImage.src = require('../../assets/kudos/' + this.wallpaper.kudos.fileName);
                    } else {
                        vm.drawKodusOnCanvas(canvas, context, vm);
                    }
                }
            },

            drawKodusOnCanvas(canvas, context, vm) {
                let protectedArea = 3 * vm.designX;
                let maxKudosWidth = canvas.width - (2 * vm.designX);
                let maxKudosHeight = canvas.height - protectedArea;

                let orientation = 'portrait';
                if (parseInt(vm.wallpaper.width) > parseInt(vm.wallpaper.height)) {
                    orientation = 'landscape';
                }
                let shortSide = Math.min(vm.wallpaper.width, vm.wallpaper.height);
                if ((orientation == 'landscape' && (shortSide > 768)) || shortSide > 1500) {
                    maxKudosHeight = maxKudosHeight * 0.5;
                    maxKudosWidth = maxKudosWidth * 0.5;
                }

                let kudosImageWidth = vm.wallpaper.kudos.imageWidth;
                let kudosImageHeight = vm.wallpaper.kudos.imageHeight;
                let relation_width = vm.round(kudosImageWidth / maxKudosWidth);
                let relation_height = vm.round(kudosImageHeight / maxKudosHeight);
                let kudosScale = 1 / Math.max(relation_width, relation_height);

                let kudosWidth = Math.floor(kudosImageWidth * kudosScale);
                let kudosHeight = Math.floor(kudosImageHeight * kudosScale);
                let kudosPositionX = Math.floor((canvas.width / 2) - (kudosWidth / 2));
                let kudosPositionY = Math.floor((canvas.height / 2) - (kudosHeight / 2));

                // Y-Position Correction to protect Logo
                let difference = (protectedArea - kudosPositionY);
                if (difference > 0) {
                    let newKudosHeight = (canvas.height - 2 * protectedArea)
                    let kudosScaling = newKudosHeight / kudosHeight;
                    kudosWidth = kudosWidth * kudosScaling;
                    kudosHeight = newKudosHeight;
                    kudosPositionX = Math.floor((canvas.width / 2) - (kudosWidth / 2));
                    kudosPositionY = Math.floor((canvas.height / 2) - (kudosHeight / 2));
                }

                try {
                    context.drawImage(vm.kudosImage, kudosPositionX, kudosPositionY, kudosWidth, kudosHeight);
                }
                catch (err) {
                    setTimeout(function () {
                        context.drawImage(vm.kudosImage, kudosPositionX, kudosPositionY, kudosWidth, kudosHeight);
                    }, 1);
                }
            },

            setPreviewDimensions() {
                let previewWrapper = document.getElementById('preview-wrapper');
                let deviceWrapper = document.getElementById('device-wrapper');
                let deviceBorderImage = document.getElementById('device-border-image');
                let deviceInteractionArea = document.getElementById('device-interaction-area');
                let deviceGlow = document.getElementById('device-glow');
                let deviceBorderCanvas = document.getElementById('device-border-canvas');
                let device = this.wallpaper.device;

                /*
                 * If a device was selected by the user, the sizes are calculated and the
                 * border is provided by a prepared SVG image
                 */
                if (device != null && typeof(device.imageName) != 'undefined') {
                    //deviceWrapper.style.height = '';
                    let device_height = device.height + device.border.top + device.border.bottom;
                    let device_width = device.width + device.border.left + device.border.right;

                    if (device_height > device_width) {
                        previewWrapper.classList.remove('is-landscape');
                        previewWrapper.classList.add('is-portrait');
                    } else {
                        previewWrapper.classList.add('is-landscape');
                        previewWrapper.classList.remove('is-portrait');
                    }

                    let max_width = deviceWrapper.offsetWidth;
                    let max_height = deviceWrapper.offsetHeight;

                    // Get 'critical' dimension factor - higher relative difference
                    let relation_width = this.round(device_width / max_width);
                    let relation_height = this.round(device_height / max_height);
                    let critical_relation = Math.max(relation_width, relation_height);

                    // Canvas Size:
                    // Maximum width = Scaled device side - (Scaled device border both sides)
                    let scaledDeviceWidth = Math.floor(device_width / critical_relation);
                    let scaledDeviceBorderLeft = Math.floor(device.border.left / critical_relation);
                    let scaledDeviceBorderRight = Math.floor(device.border.right / critical_relation);
                    let canvasWidth = scaledDeviceWidth - (scaledDeviceBorderLeft + scaledDeviceBorderRight);
                    this.previewCanvas.width = canvasWidth;
                    this.previewCanvas.style.marginLeft = scaledDeviceBorderLeft + 'px';
                    this.previewCanvas.style.marginRight = scaledDeviceBorderRight + 'px';

                    let scaledDeviceHeight = Math.floor(device_height / critical_relation);
                    let scaledDeviceBorderTop = Math.floor(device.border.top / critical_relation);
                    let scaledDeviceBorderBottom = Math.floor(device.border.bottom / critical_relation);
                    let canvasHeight = scaledDeviceHeight - (scaledDeviceBorderTop + scaledDeviceBorderBottom);
                    this.previewCanvas.height = canvasHeight;
                    this.previewCanvas.style.marginTop = scaledDeviceBorderTop + 'px';
                    this.previewCanvas.style.marginBottom = scaledDeviceBorderBottom + 'px';
                    this.wallpaperScale = this.round(1 / critical_relation);

                    // Border image
                    let borderImageSrc = require('../../assets/devices/' + device.imageName);
                    deviceBorderCanvas.classList.remove('is-custom-width');
                    deviceBorderImage.style.display = 'block';
                    deviceBorderImage.src = borderImageSrc;
                    deviceBorderImage.width = scaledDeviceWidth;

                    deviceInteractionArea.style.width = scaledDeviceWidth + 'px';
                    deviceGlow.style.width = (scaledDeviceWidth + 100) + 'px';
                    deviceGlow.style.height = (scaledDeviceHeight + 100) + 'px';
                    this.drawWallpaper(this.previewCanvas);

                } else {
                    // Custom width margins
                    let canvasMarginTop = 20;
                    let canvasMarginRight = 20;
                    let canvasMarginBottom = 20;
                    let canvasMarginLeft = 20;

                    if (parseInt(this.wallpaper.height) > parseInt(this.wallpaper.width)) {
                        previewWrapper.classList.remove('is-landscape');
                        previewWrapper.classList.add('is-portrait');
                    } else {
                        previewWrapper.classList.add('is-landscape');
                        previewWrapper.classList.remove('is-portrait');
                    }

                    //deviceWrapper.style.height = '';
                    let max_canvas_height = deviceWrapper.offsetHeight - (canvasMarginTop + canvasMarginBottom);
                    let max_canvas_width = deviceWrapper.offsetWidth - (canvasMarginLeft + canvasMarginRight);

                    if (this.wallpaper.width < max_canvas_width && this.wallpaper.height < max_canvas_height) {
                        this.previewCanvas.width = this.wallpaper.width;
                        this.previewCanvas.height = this.wallpaper.height;
                        this.wallpaperScale = 1;
                    } else {
                        // Get 'critical' dimension factor - higher relative difference
                        let relation_width = this.round(this.wallpaper.width / max_canvas_width);
                        let relation_height = this.round(this.wallpaper.height / max_canvas_height);
                        let critical_relation = Math.max(relation_width, relation_height);
                        let canvasWidth = Math.floor(this.wallpaper.width / critical_relation);
                        let canvasHeight = Math.floor(this.wallpaper.height / critical_relation);
                        this.previewCanvas.width = canvasWidth;
                        this.previewCanvas.height = canvasHeight;
                        this.wallpaperScale = this.round(1 / critical_relation);
                    }

                    if (device != null) {
                        let canvasSmallMargin = Math.round(this.previewCanvas.width * 0.014);
                        let canvasLargeMargin = Math.round(this.previewCanvas.width * 0.036);
                        canvasMarginTop = canvasSmallMargin;
                        canvasMarginRight = canvasSmallMargin;
                        canvasMarginBottom = canvasLargeMargin;
                        canvasMarginLeft = canvasSmallMargin;
                    }

                    this.previewCanvas.style.marginTop = canvasMarginTop + 'px';
                    this.previewCanvas.style.marginRight = canvasMarginRight + 'px';
                    this.previewCanvas.style.marginBottom = canvasMarginBottom + 'px';
                    this.previewCanvas.style.marginLeft = canvasMarginLeft + 'px';

                    deviceInteractionArea.style.width = this.previewCanvas.width + 'px';
                    deviceInteractionArea.style.marginLeft = canvasMarginLeft + 'px';

                    deviceGlow.style.width = (this.previewCanvas.width * 1.15) + 'px';
                    deviceGlow.style.height = (this.previewCanvas.height * 1.15) + 'px';

                    deviceBorderImage.style.display = 'none';
                    deviceBorderCanvas.style.height = (this.previewCanvas.height + canvasMarginTop + canvasMarginBottom) + 'px';
                    deviceBorderCanvas.classList.add('is-custom-width');
                    this.drawWallpaper(this.previewCanvas);
                }
            },

            onZoomChange() {
                this.drawWallpaper(this.previewCanvas);
            },
            round(number) {
                return Number((number).toFixed(4))
            },
            saveWallpaper() {
                let wallpaperCanvas = document.createElement('canvas');
                wallpaperCanvas.width = this.wallpaper.width;
                wallpaperCanvas.height = this.wallpaper.height;
                this.drawWallpaper(wallpaperCanvas);

                let fileName = this.wallpaper.pattern.name;
                if (this.wallpaper.pattern.isBW) {
                    fileName += '_bw_'
                } else {
                    fileName += '_color_'
                }
                fileName += this.wallpaper.width + 'x' + this.wallpaper.height;
                fileName += '.png';

                if (wallpaperCanvas.msToBlob) { //for IE
                    var blob = wallpaperCanvas.msToBlob();
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    wallpaperCanvas.toBlob(function (blob) {
                        saveAs(blob, fileName);
                    });
                }
            },
        },
        mounted() {
            this.previewCanvas = document.getElementById('device-canvas');
            this.ctx = this.previewCanvas.getContext("2d");

            this.setPreviewDimensions();
            document.getElementById('device-wrapper').classList.add("is-active");

            this.eventHub.$on('deviceDimensionsChanged', data => {
                if (!this.dimensionUpdate) {
                    this.dimensionUpdate = true;

                    setTimeout(_ => {
                        this.setPreviewDimensions();
                        this.dimensionUpdate = false;
                        setTimeout(_ => {
                            this.eventHub.$emit('deviceDimensionChangeFinished');
                        }, 1050);
                    }, 1000);
                }
            });

            this.eventHub.$on('refreshPreview', data => {
                this.drawWallpaper(this.previewCanvas);
            });

            this.eventHub.$on('colorChanged', data => {
                this.patternImage = null;
                this.drawWallpaper(this.previewCanvas);
            });

            this.eventHub.$on('refreshPattern', data => {
                this.patternZoom = 15;
                this.patternImage = null;
                this.patternPosition.x = 0;
                this.patternPosition.y = 0;
                this.drawWallpaper(this.previewCanvas);
            });

            this.eventHub.$on('kudosSelected', data => {
                this.kudosImage = null;
                this.drawWallpaper(this.previewCanvas);
            });

            this.eventHub.$on('showFinalScreen', data => {
                let finalFooter = document.getElementById('final-footer');
                let footerOffset = 0;
                if (this.wallpaper.device != null && typeof(this.wallpaper.device.imageName) != 'undefined') {
                    footerOffset = document.getElementById('device-border-image').clientHeight;
                } else {
                    footerOffset = document.getElementById('device-border-canvas').clientHeight;
                }
                finalFooter.style.top = (footerOffset + 40) + 'px';
            });

            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    if (this.currentPanel != 3) {
                        this.setPreviewDimensions();
                        this.drawWallpaper(this.previewCanvas)
                    }
                });
            })

        }, watch: {
            currentPanel() {
                this.drawWallpaper(this.previewCanvas);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .device {
        &__wrapper {
            //align-items: center;
            display: flex;
            height: 100%;
            justify-content: center;
            //opacity: 0;
            position: relative;
            transition: all .5s ease-in-out;
            width: 100%;
            z-index: 2;
        }

        &__border {
            display: inline-block;
            position: relative;
        }
    }

    .preview {
        &__wrapper {
            height: calc(100vh - 260px);
            margin: 100px 20px 80px 20px;
            position: relative;

            @media (min-width: 768px) {
                height: calc(100vh - 290px);
                margin-top: 130px;
            }

            @media (min-width: 1024px) {
                height: calc(100vh - 230px);
                margin: 130px 120px 100px 60px;

                &.is-landscape {
                    margin-top: 240px;
                }
            }

            @media (min-width: 1680px) {
                margin: 156px 120px 100px 60px;
            }
        }
    }

    #device-border-image {
        position: absolute;
    }

    #device-interaction-area {
        height: 100%;
        position: absolute;
        width: 100%;
        z-index: 10;

        &.panel--1 {
            cursor: move; /* fallback if grab cursor is unsupported */
            cursor: grab;
            cursor: -moz-grab;
            cursor: -webkit-grab;

            &:active {
                cursor: grabbing;
                cursor: -moz-grabbing;
                cursor: -webkit-grabbing;
            }
        }
    }

    #device-glow {
        background: transparent url('../../assets/patterns/simquadrat_bw.svg');
        filter: blur(40px);
        position: absolute;
        left: 50%;
        top: -50px;
        height: calc(100% + 100px);
        transform: translateX(-50%);
        width: 100%;
        z-index: -1;

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            display: none;
        }
    }

    #device-border-canvas {
        &.is-custom-width {
            background: #FFF;
            border-radius: 10px;
            display: inline-block;

            canvas {
                border-radius: 10px;
            }
        }
    }

    .dimension-update-enter {
        transform: translateY(200%);
    }

    .dimension-update-enter-active {
        transition: transform 1s ease-out;
    }

    .dimension-update-leave-active {
        transform: translateY(200%);
        transition: transform 1s ease-in;
    }

    // Final step
    #download-headline {

        display: none;

        @media(min-width: 768px) {
            display: block;
            color: #FFF;
            font-size: 24px;
            margin-bottom: 20px;
            position: relative;
            text-align: center;
            z-index: 10;
        }

        @media (min-width: 1024px) {
            font-size: 32px;
        }

        @media (min-width: 1680px) {
            font-size: 45px;
        }
    }

    .final-footer {
        position: absolute;
        height: 85px;
        text-align: center;
        width: 100%;
    }

    #download-link {
        border: 0;
        max-width: 240px;
        text-decoration: none;
        width: 100%;

        &:hover {
            box-shadow: -10px 8px 0 #A1A1A1;
            transform: translate(5px, -4px);
        }
    }

    #back-link {
        color: #FFF;
        cursor: pointer;
        display: block;
        margin-top: 10px;

        &:hover {
            color: #333333;
        }
    }

    .zoom-control {
        background: #FFFFFF;
        border-radius: 100px;
        height: 353px;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        width: 42px;
        z-index: 15;

        @media(min-width: 1024px) {
            right: -81px;
        }

        .zoom-button {
            border: 1px solid #d6d6d8;
            border-radius: 50%;
            background: #FFF;
            cursor: pointer;
            height: 21px;
            padding: 0;
            position: absolute;
            text-align: center;
            transform: translateX(-50%);
            transition: all .2s linear;
            width: 21px;
            left: 50%;

            &:after {
                font-family: 'PxGroteskBold';
                font-size: 14px;
                position: absolute;
            }

            &.zoom-decrease {
                bottom: 11px;

                &:after {
                    content: '';
                    display: block;
                    width: 9px;
                    height: 2px;
                    background: #000;
                    font-size: 16px;
                    transform: translate(5px, 0);
                }
            }

            &.zoom-increase {
                top: 11px;

                &:before {
                    content: '';
                    display: block;
                    width: 9px;
                    height: 2px;
                    background: #000;
                    font-size: 16px;
                    transform: translate(5px, 0) rotate(90deg);
                }

                &:after {
                    content: '';
                    display: block;
                    width: 9px;
                    height: 2px;
                    background: #000;
                    font-size: 16px;
                    transform: translate(5px, -2px);
                }
            }
        }

        .zoom-slide {
            left: 50%;
            position: absolute;
            top: 40px;
            transform: translateX(-50%);
        }
    }

    .zoom-control-enter-active {
        animation: fadeIn .5s ease-out forwards;
    }

    .zoom-control-leave-active {
        animation: fadeOut .25s ease-out forwards;
        animation: fadeOut .25s ease-out forwards;
    }

    // Animations
    .preview-enter {
        transform: translateY(200%);
    }

    .preview-enter-active {
        transition: transform 1s ease-in-out;
    }

    // States
    .is-touch {
        .zoom-control {
            display: none;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/preview/Device.vue